import { apiFetch } from '@/lib/api-client'
import type {
  AcceptInviteResponse,
  AuthResponse,
  MessageResponse,
} from './types'
import type {
  AcceptInviteInput,
  ChangePasswordFormInput,
  ForgotPasswordInput,
  LoginInput,
  RegisterInput,
  ResetPasswordInput,
} from './schemas'

export const authApi = {
  login: (input: LoginInput) =>
    apiFetch<AuthResponse>('/auth/login', {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  register: (input: RegisterInput) =>
    apiFetch<AuthResponse>('/auth/register', {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  forgotPassword: (input: ForgotPasswordInput) =>
    apiFetch<MessageResponse>('/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  resetPassword: (input: ResetPasswordInput) =>
    apiFetch<MessageResponse>('/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  acceptInvite: (input: AcceptInviteInput) =>
    apiFetch<AcceptInviteResponse>('/auth/accept-invite', {
      method: 'POST',
      body: JSON.stringify(input),
    }),

  changePassword: ({ currentPassword, newPassword }: ChangePasswordFormInput) =>
    apiFetch<MessageResponse>('/auth/change-password', {
      method: 'POST',
      body: JSON.stringify({ currentPassword, newPassword }),
    }),
}
